import * as React from "react";

const ThumbsDownIcon = ({ filled = false, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_19365_33210)">
      {filled ? (
        // Filled version - solid black fill
        <>
          <path
            d="M7.20667 15.3333C7.4928 15.3333 7.7588 15.1859 7.91047 14.9432L11 9.99998L11 1.99998L3.82407 1.99998C3.319 1.99998 2.85733 2.28531 2.63147 2.73705L1.28153 5.43691C1.0964 5.80718 1 6.21551 1 6.62951L1 9.33331C1 10.0697 1.59693 10.6666 2.33333 10.6666L6.66667 10.6666L5.98933 13.8275C5.82327 14.6025 6.41407 15.3333 7.20667 15.3333Z"
            fill="#334155"
          />
          <path
            d="M14.667 9.33333C14.667 9.70152 14.3685 10 14.0003 10L12.0003 10L12.0003 2L14.0003 2C14.3685 2 14.667 2.29847 14.667 2.66667L14.667 9.33333Z"
            fill="#334155"
          />
        </>
      ) : (
        // Outline version - stroke only
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.76355 13.3256L6.33335 10.6666L2.66669 10.6666C1.56209 10.6666 0.666687 9.77121 0.666688 8.66665L0.666688 6.62951C0.666688 6.21551 0.763088 5.80718 0.948221 5.43691L2.11389 3.10558C2.45269 2.42798 3.14522 1.99998 3.90275 1.99998L13.3334 1.99998C14.0697 1.99998 14.6667 2.59691 14.6667 3.33331L14.6667 8.66665C14.6667 9.40303 14.0697 9.99998 13.3334 9.99998L11.3334 9.99998L8.32509 14.8132C8.12289 15.1368 7.76822 15.3333 7.38669 15.3333C6.32989 15.3333 5.54215 14.3589 5.76355 13.3256ZM11.3334 8.99998L13.3334 8.99998C13.5174 8.99998 13.6667 8.85071 13.6667 8.66665L13.6667 3.33331C13.6667 3.14925 13.5174 2.99998 13.3334 2.99998L11.3334 2.99998L11.3334 8.99998ZM3.00836 3.55278C3.17769 3.21398 3.52395 2.99998 3.90275 2.99998L10.3334 2.99998L10.3334 9.71318L7.47709 14.2832C7.45762 14.3144 7.42342 14.3333 7.38669 14.3333C6.96655 14.3333 6.65335 13.9459 6.74135 13.5351L7.31115 10.8762C7.37442 10.5809 7.30089 10.2728 7.11102 10.038C6.92115 9.80312 6.63535 9.66665 6.33335 9.66665L2.66669 9.66665C2.11442 9.66665 1.66669 9.21891 1.66669 8.66665L1.66669 6.62951C1.66669 6.37078 1.72695 6.11558 1.84262 5.88411L3.00836 3.55278Z"
          fill="#334155"
        />
      )}
    </g>
    <defs>
      <clipPath id="clip0_19365_33210">
        <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(-180)" />
      </clipPath>
    </defs>
  </svg>
);

export default ThumbsDownIcon;
